/**
 * Stream Mode Indicator
 *
 * Badge showing current identity mode.
 */

import type { IdentityMode } from '@personic/shared'

interface StreamModeIndicatorProps {
  mode: IdentityMode
  compact?: boolean
}

const modeConfig: Record<IdentityMode, { label: string; bg: string; text: string; icon: string }> = {
  self_focused: { label: 'Self', bg: 'bg-blue-100', text: 'text-blue-700', icon: '🪞' },
  counterparty_focused: { label: 'Counterparty', bg: 'bg-amber-100', text: 'text-amber-700', icon: '🎯' },
  both: { label: 'Dual-Stream', bg: 'bg-emerald-100', text: 'text-emerald-700', icon: '🔄' },
}

export default function StreamModeIndicator({ mode, compact }: StreamModeIndicatorProps) {
  const config = modeConfig[mode] || modeConfig.self_focused

  if (compact) {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
        {config.icon} {config.label}
      </span>
    )
  }

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg ${config.bg}`}>
      <span className="text-lg">{config.icon}</span>
      <div>
        <span className={`text-sm font-semibold ${config.text}`}>{config.label}</span>
        <span className={`text-xs ml-1 ${config.text} opacity-70`}>mode</span>
      </div>
    </div>
  )
}
